<template>
	<el-dialog title="确认认领" width="400px" show-close :visible.sync="claimDialog">
		<template slot="title">
			<p>
				<span>确认认领</span>
				<span class="fz-14 yx-color-text-regular ml-6">{{ '(共' + total + '个商品)' }}</span>
			</p>
		</template>
		<p>{{ tips ? tips : '待审核商品需先完成审核后分配招商运营，当前操作将自动过滤待审核状态的商品，确认要继续认领商品吗？' }}</p>
		<div slot="footer" class="dialog-footer">
			<el-button @click="claimDialog = false">取 消</el-button>
			<el-button type="primary" @click="claimConfirm">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { productReceive } from '@/api/shopManage';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	data() {
		return {
			claimDialog: false,
			params: {
				product_ids: '',
			},
			total: 1,
			tips: '',
		};
	},
	methods: {
		initClaim(row, tips) {
			this.tips = tips;
			this.params = {
				product_ids: '',
			};
			if (Array.isArray(row)) {
				if (!row.length) {
					this.$message.warning('请选择商品');
					return;
				}
				this.params.product_ids = row.map(item => item.product_id).join(',');
				this.total = row.length;
			} else {
				this.total = 1;
				this.params.product_ids = row.product_id;
			}
			this.claimDialog = true;
			this.params.platform_id = this.platformId;
		},
		async claimConfirm() {
			const { code } = await productReceive(this.params);
			if (code == 0) {
				this.$message.success('认领成功');
				this.$emit('refreshList');
				this.claimDialog = false;
			}
		},
	},
};
</script>
